export const emailRE = /^\w+([.-]?\w+)+@\w+([.:]?\w+)+(\.[a-zA-Z0-9]{2,3})+$/;
export const numberRE = /^\d+$/;
export const letterRE = /^[a-zA-Z]+$/;
export const chineseRE = /^[\u4e00-\u9fa5]+$/;
export const phoneRE = /^1(3|4|5|6|7|8|9)\d{9}$/;
